module.exports = __webpack_public_path__ + "static/media/tab-9-image-1.e3040520.png";